import DeleteInvoiceForm from 'src/components/Forms/DeleteInvoiceForm';
import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';

const DeleteInvoiceModal = () => (
  <ModalBase
    name={MODALS.deleteInvoice}
    size={MODALS_SIZE.small}
    height="60px">
    <DeleteInvoiceForm />
  </ModalBase>
);

export default DeleteInvoiceModal;
